export const servicesData = [
  {
    service_id: "service_id_1",
    title: "Travel Packages",
    tagline: "Curated trips & itineraries",
    imageUrl: "/assets/travel.jpeg",
    content:
      "Explore the wonders of far-off lands, savor local flavors, and create lasting connections with the people and places you encounter.",
    readMoreLink: "/travel",
    detailsContent: [
      "Expertly crafted itineraries tailored to your preferences and interests.",
      "A diverse range of destinations spanning exotic locales, cultural hotspots, and natural wonders.",
      "Comprehensive packages that include accommodation, transportation, and guided tours.",
      "Flexible options for solo travelers, couples, families, and group tours.",
      "24/7 customer support to address any queries or concerns during your journey.",
      "Exclusive access to unique experiences and local insights, curated by seasoned travel experts.",
      "Specialized packages for adventure seekers, wellness enthusiasts, and luxury travelers.",
      "Customizable packages allowing you to add or remove activities based on your preferences.",
      "Budget-friendly options without compromising on quality or experience.",
      "Peace of mind knowing your travel arrangements are in the hands of trusted professionals.",
    ],
  },
  {
    service_id: "service_id_2",
    title: "Travel Insurance",
    tagline: "Coverage for your journey",
    imageUrl: "/assets/insurance.jpeg",
    content:
      "Our Travel Insurance plans offer comprehensive coverage for your adventures, business trips, leisure getaways, or planning a relaxing vacation.",
    readMoreLink: "/insurance",
    detailsContent: [
      "Comprehensive coverage for medical emergencies, trip cancellations, and lost luggage.",
      "Flexible plans tailored to your travel needs, including single trip and annual coverage options.",
      "Assistance and support services available worldwide, ensuring you're never far from help.",
      "Easy online application process with instant policy issuance and documentation.",
      "Peace of mind knowing you're protected against unforeseen events during your travels.",
      "Coverage for a wide range of activities, including adventure sports and extreme activities.",
      "Additional benefits such as emergency medical evacuation and repatriation services.",
      "Access to a global network of medical providers and assistance centers.",
      "Customizable coverage options to suit your specific travel requirements and preferences.",
      "Competitive premiums with flexible payment options for added convenience.",
    ],
  },
  {
    service_id: "service_id_3",
    title: "Immigration Assistance",
    tagline: "Visa & relocation support",
    imageUrl: "/assets/immigration.jpeg",
    content:
      "Navigate the immigration process seamlessly with our expert guidance. Overcome complexities and achieve your goals confidently with our dedicated assistance.",
    readMoreLink: "/immigration",
    detailsContent: [
      "Personalized guidance and support throughout the immigration process.",
      "Expert advice on visa applications, documentation requirements, and legal procedures.",
      "Assistance with relocation services, including housing, schooling, and healthcare.",
      "Access to a network of immigration professionals and legal experts for specialized needs.",
      "Tailored solutions for individuals, families, and businesses seeking immigration assistance.",
      "Updates on changes to immigration laws, policies, and regulations affecting your case.",
      "Guidance on citizenship applications, naturalization processes, and permanent residency.",
      "Preparation and review of application materials to ensure accuracy and completeness.",
      "Strategic advice on immigration strategies and options for achieving your long-term goals.",
      "Peace of mind knowing your immigration matters are handled with expertise and care.",
    ],
  },
];
